import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as SettingsActions, Types as SettingsTypes } from 'store/ducks/settings';

function* getSettingRequest(action) {
  try {
    const { id } = action.payload;
    const url = `settings/v2/confs/${id}`;
    const response = yield call(api.get, url);

    yield put(SettingsActions.getSettingSuccess(response.data));
  } catch (error) {
    yield put(SettingsActions.getSettingFailure());
  }
}

function* getSettingsRequest(action) {
  try {
    const { page, filter } = action.payload;
    const search = filter !== null ? `&search=${filter.query}` : '';
    const url = `settings/v2/confs?page=${page}&per=25${search}`;
    const response = yield call(api.get, url);

    yield put(SettingsActions.getSettingsSuccess(response.data));
  } catch (error) {
    yield put(SettingsActions.getSettingsFailure());
  }
}

function* updateSettingRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `settings/v2/confs/${id}`;
    const response = yield call(api.put, url, data);

    yield put(push('/configs/settings'));
    yield call(swal, 'Atualizado', 'Configuração atualizada', 'success');
    yield put(SettingsActions.updateSettingSuccess(response.data));
  } catch (error) {
    yield put(SettingsActions.updateSettingFailure());
  }
}

export default function* sagaSettings() {
  yield takeLatest(SettingsTypes.GET_REQUEST, getSettingRequest);
  yield takeLatest(SettingsTypes.GET_LIST_REQUEST, getSettingsRequest);
  yield takeLatest(SettingsTypes.UPDATE_REQUEST, updateSettingRequest);
}
